import { useQuery } from '@tanstack/react-query';

import { fetchPerformanceTrend } from '@/entities/insight';
import type { PublicFilter } from '../public-filter/use-public-filter';

export function usePerformance({
  period,
  startDate,
  endDate,
  queryId,
  enabled,
  publicFilter,
}: {
  queryId: string;
  startDate: string;
  endDate: string;
  period: 'monthly' | 'weekly' | 'daily';
  enabled: boolean;
  publicFilter: PublicFilter;
}) {
  return useQuery({
    queryKey: ['performance', queryId, startDate, endDate, publicFilter, period, enabled],
    queryFn: ({ signal }) =>
      fetchPerformanceTrend({ queryId, startDate, endDate, publicFilter, period }, signal),
    placeholderData: (previousData) => previousData,
    enabled,
  });
}
